import Vue from "vue"
import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyDZjAMqmqMFwnx0yDVkqNAD3sI4S_c91Ps",
		libraries: "places,geometry",
		region: "ID",
		language: "id",
		v: '3.26'
	},
  installComponents: true
})

export default VueGoogleMaps